import { render, staticRenderFns } from "./Workers.vue?vue&type=template&id=110e8252&scoped=true"
import script from "./Workers.vue?vue&type=script&lang=js"
export * from "./Workers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110e8252",
  null
  
)

export default component.exports